import { render, staticRenderFns } from "./localShow.vue?vue&type=template&id=5e9b91da&scoped=true&"
import script from "./localShow.vue?vue&type=script&lang=js&"
export * from "./localShow.vue?vue&type=script&lang=js&"
import style0 from "./localShow.vue?vue&type=style&index=0&id=5e9b91da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9b91da",
  null
  
)

export default component.exports